const prefix = 'control'

export const SET_SNACKBAR = `${prefix}/SET_SNACKBAR`
export const POP_SNACKBAR = `${prefix}/POP_SNACKBAR`
export const SET_CONFIRMATION_DIALOG = `${prefix}/SET_CONFIRMATION_DIALOG`
export const POP_CONFIRMATION_DIALOG = `${prefix}/POP_CONFIRMATION_DIALOG`
export const SET_LOADING = `${prefix}/SET_LOADING`
